import {Edit, Printer, Trash, UserRound, X, ArrowLeft, ArrowRight, CircleCheck, CircleMinus, Plus, CirclePlus} from "lucide-react"
import React from "react"

const Icons = (iconColor = "#000") => ({
    "edit": <Edit color={iconColor} />,
    "trash": <Trash color={iconColor} />,
    "printer": <Printer color={iconColor} />,
    "user": <UserRound color={iconColor} />,
    "x": <X color={iconColor} />,
    "plus": <Plus color={iconColor} />,
    "circle-plus": <CirclePlus color={iconColor} />,
    "arrow-left": <ArrowLeft color={iconColor} />,
    "arrow-right": <ArrowRight color={iconColor} />,
    "checked-outlined": <CircleCheck color={iconColor} />,
    "minus-outlined": <CircleMinus color={iconColor} />,
})

export default Icons